import { createContext, useContext, useEffect, useState } from "react";

export const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log('[Auth] App mount — Token exists:', !!localStorage.getItem("Token"), 'UserId:', localStorage.getItem("UserId"), 'RefreshToken exists:', !!localStorage.getItem("RefreshToken"));
        // Always coerce to Number — every other place in the app (login
        // response, API data, hierarchy filter, downline lookup) treats
        // userId as a numeric id. localStorage stringifies it, so without
        // this coercion `===` comparisons like `u.uplineId === myId` fail
        // (1 === "1" is false) and downlines disappear from any page that
        // does that comparison after a page reload.
        const userIdRaw = localStorage.getItem("UserId");
        const userId = userIdRaw != null && userIdRaw !== '' ? Number(userIdRaw) : null;
        const username = localStorage.getItem("Username");
        const firstName = localStorage.getItem("FirstName");
        const lastName = localStorage.getItem("LastName");
        const roles = JSON.parse(localStorage.getItem("Roles")) || [];
        const roleRights = JSON.parse(localStorage.getItem("RoleRights")) || [];
        const groupName = localStorage.getItem("GroupName");
        const profilePhotoUrl = localStorage.getItem("ProfilePhotoUrl");
        const mustAcceptAgreement = localStorage.getItem("MustAcceptAgreement") === "true";
        const applicationStatus = localStorage.getItem("ApplicationStatus") || "Active";

        if (userId) {
            setUser({ userId, username, firstName, lastName, roles, roleRights, groupName, profilePhotoUrl, mustAcceptAgreement, applicationStatus });
        } else {
            setUser(null);
        }
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
                <div className="spinner"></div>
                <span>Loading...</span>
            </div>
        );
    }

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}